// Pagina „Povestea noastră”: galeria de categorii și apariția treptată a secțiunilor.
if (!customElements.get('fe-about-gallery')) {
  customElements.define('fe-about-gallery', class extends HTMLElement {
    connectedCallback() {
      this.abort = new AbortController();
      const signal = this.abort.signal;
      this.gallery = this.querySelector('.needs-gallery');
      this.prev = this.querySelector('[data-gallery="prev"]');
      this.next = this.querySelector('[data-gallery="next"]');
      if (!this.gallery || !this.prev || !this.next) return;
      const update = () => {
        this.prev.disabled = this.gallery.scrollLeft < 5;
        this.next.disabled = this.gallery.scrollLeft + this.gallery.clientWidth >= this.gallery.scrollWidth - 5;
      };
      [this.prev, this.next].forEach((button) => button.addEventListener('click', () => {
        const card = this.gallery.querySelector('.category-card');
        if (!card) return;
        this.gallery.scrollBy({
          left: (card.getBoundingClientRect().width + 18) * (button === this.prev ? -1 : 1),
          behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
        });
      }, { signal }));
      this.gallery.addEventListener('scroll', update, { passive: true, signal });
      window.addEventListener('resize', update, { signal });
      update();
    }
    disconnectedCallback() { this.abort?.abort(); }
  });
}

if (!window.__feAboutReveal) {
  window.__feAboutReveal = true;
  const start = () => {
    if (!('IntersectionObserver' in window) || matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    if (window.Shopify && Shopify.designMode) return;
    const observer = new IntersectionObserver((entries) => entries.forEach((entry) => {
      if (entry.isIntersecting) { entry.target.classList.remove('pending'); observer.unobserve(entry.target); }
    }), { threshold: 0.08 });
    document.querySelectorAll('.fedespre .story-copy, .fedespre .section-heading, .fedespre .value-grid article, .fedespre .manifesto h2').forEach((el) => {
      el.classList.add('reveal', 'pending');
      observer.observe(el);
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
}
